<template>
  <div>
    <cardContract
      :seahorseCount="seahorseCount"
      :seahorseContractCount="seahorseContractCount"
      :seahorseEquimentCount="seahorseEquimentCount"
      :magylotteryCount="magylotteryCount"
      :magylotteryContractCount="magylotteryContractCount"
      :magylotteryEquimentCount="magylotteryEquimentCount"
      :ncfmovilCount="ncfmovilCount"
      :ncfmovilContractCount="ncfmovilContractCount"
      :ncfmovilEquimentCount="ncfmovilEquimentCount"
      :magypagoCount="magypagoCount"
      :magypagoContractCount="magypagoContractCount"
      :magypagoEquimentCount="magypagoEquimentCount"
      :magytrackCount="magytrackCount"
      :magytrackContractCount="magytrackContractCount"
      :magytrackEquimentCount="magytrackEquimentCount"
      :navixyCount="navixyCount"
      :navixyEquimentCount="navixyEquimentCount"
      :navixyNavisionCount="navixyNavisionCount"
      :navixyNavisionEquimentCount="navixyNavisionEquimentCount"
      :navixyWithoutUserCount="navixyWithoutUserCount"
      :navixyWithoutEquimentCount="navixyWithoutEquimentCount"
      :companyCode="currentCompany"
    >
    </cardContract>
    <div
      class="mr-1 display-flex"
      style="margin-left: 830px; margin-bottom: 10px"
    >
      <el-select
        style="width: 300px"
        placeholder="Cliente"
        v-model="filterParameters.CustomerId"
        filterable
        size="mini"
        clearable
        @change="onChangeCustomer"
      >
        <el-option
          v-for="customer in customerList"
          :key="customer.ClientCode"
          :label="customer.Name"
          :value="customer.ClientCode"
        ></el-option>
      </el-select>

      <SellerSelector
        style="width: 300px"
        v-model="filterParameters.SellerId"
        @change="onChangeSeller"
      />

      <CustomerServiceSelector
        style="width: 300px"
        v-model="filterParameters.CustomerServiceId"
        @change="onChangeCustomerService"
      />

      <PaymentAgentSelector
        style="width: 300px"
        v-model="filterParameters.PaymentAgentId"
        @change="onChangePaymentAgent"
      />

      <el-select
        placeholder="Estatus"
        v-model="IsOpen"
        filterable
        clearable
        size="mini"
        @change="handleContractType"
      >
        <el-option
          v-for="(s, index) in TypeContract"
          :key="index"
          :value="s.value"
          :label="s.label"
        >
        </el-option>
      </el-select>
    </div>
    <el-tabs
      type="border-card"
      :before-leave="beforeLeaveM"
      v-model="activeName"
      style="width: 100%"
      class="alex"
    >
      <el-tab-pane label="SEAHORSE" name="SEAHORSE" v-if="isCurrentSEAHORSE">
        <ContractTable
          v-if="activeName === 'SEAHORSE'"
          ref="tabSEAHORSE"
          :StatusContract="IsOpen"
          v-bind="filtersFor('SEAHORSE')"
        />
      </el-tab-pane>
      <el-tab-pane
        label="MAGYLOTTERY"
        name="MAGYLOTTERY"
        v-if="isCurrentMAGYLOTTERY"
      >
        <ContractTable
          v-if="activeName === 'MAGYLOTTERY'"
          ref="tabMAGYLOTTERY"
          v-bind="filtersFor('MAGYLOTTERY')"
        />
      </el-tab-pane>
      <el-tab-pane label="NCF MOVIL" name="MOVIL" v-if="isCurrentMOVIL">
        <ContractTable
          v-if="activeName === 'MOVIL'"
          ref="tabMOVIL"
          :StatusContract="IsOpen"
          v-bind="filtersFor('MOVIL')"
        />
      </el-tab-pane>
      <el-tab-pane label="MAGYPAGO" name="MAGYPAGO" v-if="isCurrentMAGYPAGO">
        <ContractTable
          v-if="activeName === 'MAGYPAGO'"
          ref="tabMAGYPAGO"
          :StatusContract="IsOpen"
          v-bind="filtersFor('MAGYPAGO')"
        />
      </el-tab-pane>
      <el-tab-pane label="MAGYTRACK" name="MAGYTRACK" v-if="isCurrentMAGYTRACK">
        <ContractTable
          v-if="activeName === 'MAGYTRACK'"
          ref="tabMAGYTRACK"
          :StatusContract="IsOpen"
          v-bind="filtersFor('MAGYTRACK')"
        />
      </el-tab-pane>
      <el-tab-pane label="MVIEW" name="MVIEW" v-if="isCurrentUserMVIEW">
        <ContractTable
          v-if="activeName === 'MVIEW'"
          ref="tabMVIEW"
          :StatusContract="IsOpen"
          v-bind="filtersFor('MVIEW')"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ContractTable from "@/components/ContractTable.vue";
import store from "@/store";
import { COMPANYS } from "@/const";
import cardContract from "@/components/CardsContracts.vue";
import CustomerServiceSelector from "@/components/Company/CustomerServiceSelector.vue";
import PaymentAgentSelector from "@/components/Company/PaymentAgentSelector.vue";
import SellerSelector from "@/components/Company/SellerSelector.vue";

export default {
  name: "ContractList",
  components: {
    ContractTable,
    cardContract,
    CustomerServiceSelector,
    PaymentAgentSelector,
    SellerSelector
  },
  data() {
    return {
      activeName: this.MuestraData(),
      currentDate: new Date(),
      asyncComponent: "peity",
      summary: {
        QuantityAmountContract: 260,
        TotalAmountContract: 4831482.21,
        QuantityAmountOpenContract: 260,
        TotalAmountOpenContract: 4831482.21,
        QuantityAmountCloseContract: 0,
        TotalAmountCloseContract: 0,
        TotalQtyTerminal: 2017,
        QtyOpenTerminal: 2017,
        QtyCloseTerminal: 0
      },
      seahorseCount: 0,
      seahorseContractCount: 0,
      seahorseEquimentCount: 0,
      magylotteryCount: 0,
      magylotteryContractCount: 0,
      magylotteryEquimentCount: 0,
      ncfmovilCount: 0,
      ncfmovilContractCount: 0,
      ncfmovilEquimentCount: 0,
      magypagoCount: 0,
      magypagoContractCount: 0,
      magypagoEquimentCount: 0,
      magytrackCount: 0,
      magytrackContractCount: 0,
      magytrackEquimentCount: 0,
      //navixyNavisionCount: 0,
      isCurrentSEAHORSE: false,
      isCurrentMOVIL: false,
      isCurrentMAGYPAGO: false,
      isCurrentMAGYLOTTERY: false,
      isCurrentUserMVIEW: false,
      isCurrentMAGYTRACK: false,
      IsOpen: "Abierto",
      TypeContract: [
        {
          value: "1",
          label: "Cerrado"
        },
        {
          value: "0",
          label: "Abierto"
        }
      ],
      filterParameters: {
        CustomerId: "",
        SellerId: "",
        CustomerServiceId: "",
        PaymentAgentId: ""
      },
      customerList: []
    };
  },

  mounted() {
    this.MuestraData();
    if (store.state.user.user.CompanySelected == COMPANYS.MTR) {
      this.MagytrackCount();
      this.magytrackAmountAndQtyCount();
    } else if (store.state.user.user.CompanySelected == COMPANYS.TB) {
      this.SeahorseCount();
      this.MagyLotteryCount();
      this.NcfMofilCount();
      this.MagyPagoCount();
      this.SeahorseAmountAndQtyCount();
      this.MagylotteryAmountAndQtyCount();
      this.NcfMovilAmountAndQtyCount();
      this.MagypagoAmountAndQtyCount();
      this.MagytrackCount();
      this.magytrackAmountAndQtyCount();
      this.CustomerForFilter();
    }
  },
  methods: {
    ...mapActions({
      getTotalUsers: "navixy/getTotalUsers",
      getNaviNavixyDiff: "navixy/getNaviNavixyDiff"
    }),
    MuestraData() {
      // if (store.state.user.user.CompanySelected == COMPANYS.MTR) {
      // this.activeName = "MAGYTRACK";
      this.isCurrentMAGYTRACK = true;
      // }
      // if (store.state.user.user.CompanySelected == COMPANYS.TB) {
      this.activeName = "MOVIL";
      this.isCurrentSEAHORSE = true;
      this.isCurrentMOVIL = true;
      this.isCurrentMAGYPAGO = true;
      this.isCurrentMAGYLOTTERY = true;
      this.isCurrentMAGYTRACK = true;
      this.CustomerForFilter();
      // }
    },
    filtersFor(tabName) {
      return this.activeName === tabName
        ? { filters: this.filterParameters }
        : {};
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // eslint-disable-next-line no-unused-vars
    beforeLeaveM(activeName, oldActiveName) {
      this.activeName = activeName;
      let self = this;
      this.$nextTick(() => {
        if (self.$refs[`tab${activeName}`]) {
          self.$refs[`tab${activeName}`].getData(activeName);
        }
      });
    },
    SeahorseCount() {
      this.$http
        .get(
          `/api/contracts?CompanyCode=${this.currentCompany}&Page=1&Skip=0&Limit=10&Status=${this.IsOpen}&ProductName=SEAHORSE&Option=H`
        )
        .then((resp) => {
          this.seahorseContractCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    MagyLotteryCount() {
      this.$http
        .get(
          `/api/contracts?CompanyCode=${this.currentCompany}&Page=1&Skip=0&Limit=10&Status=&ProductName=MAGYLOTTERY&Option=H`
        )
        .then((resp) => {
          this.magylotteryContractCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    NcfMofilCount() {
      this.$http
        .get(
          `/api/contracts?CompanyCode=${this.currentCompany}&Page=1&Skip=0&Limit=10&Status=${this.IsOpen}&ProductName=MOVIL&Option=H`
        )
        .then((resp) => {
          this.ncfmovilContractCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    MagyPagoCount() {
      this.$http
        .get(
          `/api/contracts?CompanyCode=${this.currentCompany}&Page=1&Skip=0&Limit=10&Status=${this.IsOpen}&ProductName=MAGYPAGO&Option=H`
        )
        .then((resp) => {
          this.magypagoContractCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    SeahorseAmountAndQtyCount() {
      this.$http
        .get(
          `/api/contracts/GetContractSummaryAsync?CompanyCode=${this.currentCompany}&ContractStatus=Open&ProductName=SEAHORSE&Status=${this.IsOpen}`
        )
        .then((resp) => {
          this.seahorseCount = this.formatPrice(resp.data.TotalAmountOpen); // amount
          this.seahorseEquimentCount = resp.data.TotalEquipmentOpen; // Equiment
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    MagylotteryAmountAndQtyCount() {
      this.$http
        .get(
          `/api/contracts/GetContractSummaryAsync?CompanyCode=${this.currentCompany}&ContractStatus=Open&ProductName=MAGYLOTTERY`
        )
        .then((resp) => {
          this.magylotteryCount = this.formatPrice(resp.data.TotalAmountOpen); // amount
          this.magylotteryEquimentCount = resp.data.TotalEquipmentOpen; // Equiment
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    NcfMovilAmountAndQtyCount() {
      this.$http
        .get(
          `/api/contracts/GetContractSummaryAsync?CompanyCode=${this.currentCompany}&ContractStatus=Open&ProductName=MOVIL&Status=${this.IsOpen}`
        )
        .then((resp) => {
          this.ncfmovilCount = this.formatPrice(resp.data.TotalAmountOpen); // amount
          this.ncfmovilEquimentCount = resp.data.TotalEquipmentOpen; // Equiment
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    MagypagoAmountAndQtyCount() {
      this.$http
        .get(
          `/api/contracts/GetContractSummaryAsync?CompanyCode=${this.currentCompany}&ContractStatus=Open&ProductName=MAGYPAGO&Status=${this.IsOpen}`
        )
        .then((resp) => {
          this.magypagoCount = this.formatPrice(resp.data.TotalAmountOpen); // amount
          this.magypagoEquimentCount = resp.data.TotalEquipmentOpen; // Equiment
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    MagytrackCount() {
      this.$http
        .get(
          `/api/contracts?CompanyCode=${this.currentCompany}&Page=1&Skip=0&Limit=10&Status=${this.IsOpen}&ProductName=MAGYTRACK&Option=H`
        )
        .then((resp) => {
          this.magytrackContractCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    magytrackAmountAndQtyCount() {
      this.$http
        .get(
          `/api/contracts/GetContractSummaryAsync?CompanyCode=${this.currentCompany}&ContractStatus=Open&ProductName=MAGYTRACK&Status=${this.IsOpen}`
        )
        .then((resp) => {
          this.magytrackCount = this.formatPrice(resp.data.TotalAmountOpen); // amount
          this.magytrackEquimentCount = resp.data.TotalEquipmentOpen; // Equiment
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    CustomerForFilter() {
      this.$http
        .get("/api/customers/getallCustomer")
        .then((resp) => {
          this.customerList = resp.data;
        })
        .catch(() => {
          this.customerList = [];
        });
    },

    handleContractType() {
      this.SeahorseAmountAndQtyCount();
      this.NcfMofilCount();
      this.MagytrackCount();
      this.SeahorseCount();
      this.NcfMovilAmountAndQtyCount();
      this.MagypagoAmountAndQtyCount();
      this.MagyPagoCount();
      this.magytrackAmountAndQtyCount();
    },

    onChangeSeller(SalesPersonCode) {
      this.filterParameters.SellerId = SalesPersonCode;
    },

    onChangeCustomerService(customerServiceId) {
      this.filterParameters.CustomerServiceId = customerServiceId;
    },

    onChangePaymentAgent(paymentAgentId) {
      this.filterParameters.PaymentAgentId = paymentAgentId;
    },

    onChangeCustomer(customerId) {
      this.filterParameters.CustomerId = customerId;
    }
  },
  computed: {
    ...mapState({
      navixyEquimentCount: (state) => state.navixy.total_gps,
      navixyCount: (state) => state.navixy.total_users,
      navixyWithoutUserCount: (state) =>
        state.navixy.reportUserNotContract.length,
      navixyWithoutEquimentCount: (state) =>
        state.navixy.qtyOfEquipmentWithoutContract,
      navixyNavisionCount: (state) =>
        state.navixy.reportUserNotContract2.length,
      navixyNavisionEquimentCount: (state) =>
        state.navixy.qtyOfEquipmentWiNAVNAV
    })
  }
};
</script>

<style lang="scss" scoped>
.col-filter {
  background-color: red;
  height: 60px;
}

.el-tabs__content {
  padding: 0 !important;
}
</style>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.alex {
  width: 100%;
}
</style>

<style lang="scss" scoped>
@import "../../../../assets/scss/_variables";

.widget {
  height: auto;
  position: relative;

  .widget-header {
    .widget-icon-box {
      background: rgba(0, 0, 0, 0.02);
      border: 1px solid rgba(0, 0, 0, 0.02);
      border-radius: 4px;
      text-align: center;
      width: 60px;
      padding: 5px;
    }

    .widget-title {
      font-weight: bold;
    }
  }

  .badge-box {
    .badge {
      display: inline-block;
      border-radius: 4px;
      font-size: 80%;
    }
  }
}

@media (min-width: 768px) and (max-width: 1040px) {
  .widget {
    .widget-header {
      .widget-icon-box {
        display: none;
      }
    }
  }
}

.display-flex {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
